var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.875C15.3477 0.875 15.875 1.40234 15.875 2.03516V15.5C15.875 16.1328 15.3477 16.625 14.75 16.625H1.21484C0.617188 16.625 0.125 16.1328 0.125 15.5V2.03516C0.125 1.40234 0.617188 0.875 1.21484 0.875H14.75ZM4.87109 14.375V6.88672H2.55078V14.375H4.87109ZM3.71094 5.83203C4.44922 5.83203 5.04688 5.23438 5.04688 4.49609C5.04688 3.75781 4.44922 3.125 3.71094 3.125C2.9375 3.125 2.33984 3.75781 2.33984 4.49609C2.33984 5.23438 2.9375 5.83203 3.71094 5.83203ZM13.625 14.375V10.2617C13.625 8.25781 13.168 6.67578 10.8125 6.67578C9.6875 6.67578 8.91406 7.30859 8.59766 7.90625H8.5625V6.88672H6.34766V14.375H8.66797V10.6836C8.66797 9.69922 8.84375 8.75 10.0742 8.75C11.2695 8.75 11.2695 9.875 11.2695 10.7188V14.375H13.625Z",
    fill: "#0075B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.6024d971f1fd07acddb00136f1f529a9.svg";
export { ForwardRef as ReactComponent };